import { render } from "./search-watchlist.vue?vue&type=template&id=476f2e6e"
import script from "./search-watchlist.vue?vue&type=script&lang=js"
export * from "./search-watchlist.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__